import styled from "styled-components";
import { Link } from "react-router-dom";
import { rem, em } from "convert-to-ems";

export const Header = styled.header`
  background-color: ${props => props.theme.backgroundColor};
  display: flex;
  flex-direction: row;
  height: ${rem(56)};
  width: 100%;
  align-items: center;
  justify-content: ${props => props.justifyContent};
`;

export const HomeLink = styled(Link)`
  width: ${rem(166)};
  margin-left: ${props => props.theme.headerMarginLeft};
`;

export const ArrowBack = styled(Link)`
  width: ${rem(30)};
  margin-left: ${props => props.theme.headerMarginLeft};

  @media (${props => props.theme.breakpoints.medium}) {
    width: ${rem(40)};
  }
`;

export const Brands = styled.div`
  width: ${rem(350)};
  img {
    @media (${props => props.theme.breakpoints.mobile}) {
      display: none;
    }
  }
`;

export const Brand = styled.img`
  display: block;
  height: ${props => props.theme.headerBrandsHeight};
  margin-left: ${props => props.theme.headerBrandsMarginLeft};
  float: left;
`;

export const Elo = styled(Brand)``;

export const Master = styled(Brand)``;

export const Visa = styled(Brand)``;

export const Paypal = styled(Brand)``;

export const HiperCard = styled(Brand)``;

export const Pix = styled(Brand)``;

export const StyledLinkDoubts = styled(Link)`
  margin-right: ${rem(20)};
  display: flex;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
  color: ${props => props.theme.baseColor};

  img {
    margin-bottom: ${rem(3)};
  }

  @media (${props => props.theme.breakpoints.mobile}) {
    font-size: ${em(12)};
    opacity: 0.8;
  }
`;

export const CloseHeader = styled(Link)`
  margin-left: ${props => props.theme.headerMarginLeft};
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${props => props.theme.baseColor};

  img {
    margin-right: ${rem(10)};

    @media (${props => props.theme.breakpoints.medium}) {
      width: ${rem(30)};
    }
  }

  p {
    @media (${props => props.theme.breakpoints.medium}) {
      font-size: ${em(20)};
    }
  }
`;

export const BannerLanding = styled.button`
  padding: 0;
  border: none;
  width: 100%;
`;

BannerLanding.Content = styled.img.attrs(props => ({
  src: props.src,
  alt: props.alt,
}))`
  width: 100%;
`;

export const HeaderLogo = styled.div`
  button {
    background: transparent;
    border: none;
  }

  img {
    margin-left: ${rem(5)};
    margin-top: ${rem(10)};
    margin-bottom: ${rem(12)};
  }

  p {
    color: #fff;
    font-size: 16px;

    @media (${props => props.theme.breakpoints.mobile}) {
      font-size: 11px;
    }
  }
`;
